module.exports = __webpack_public_path__ + "static/media/strzalka.eba8cd28.svg";